/**
 * Creates a canvas layer that covers `container`. Layers are stacked in the
 * order they are created.
 *
 * @param {HTMLElement} container
 * @returns {HTMLCanvasElement}
 */
export const createLayerCanvas = (container) => {
  const canvas = document.createElement("canvas");

  Object.assign(canvas.style, {
    position: "absolute",
    left: "0",
    top: "0",
    display: "block",
  });
  container.appendChild(canvas);

  return canvas;
};

/**
 * Sets the CSS size of a layer and its backing store size in device pixels.
 *
 * @param {HTMLCanvasElement} canvas
 * @param {{ width: number, height: number, pixelRatio: number }} size
 */
export const resizeLayerCanvas = (canvas, { width, height, pixelRatio }) => {
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  canvas.width = Math.max(1, Math.round(width * pixelRatio));
  canvas.height = Math.max(1, Math.round(height * pixelRatio));
};

/**
 * Puts a new canvas layer in the place of `canvas` (same position in the
 * stack) and removes the old one. A canvas keeps the first context type it
 * was asked for, so a switch from WebGL to Canvas 2D needs a new element.
 *
 * @param {HTMLCanvasElement} canvas
 * @returns {HTMLCanvasElement}
 */
export const replaceLayerCanvas = (canvas) => {
  const nextCanvas = document.createElement("canvas");

  nextCanvas.style.cssText = canvas.style.cssText;
  canvas.replaceWith(nextCanvas);

  return nextCanvas;
};
